import { Action, getModule, Module, MutationAction, VuexModule } from 'vuex-module-decorators';
import store from '@/store';
import { Profile, User, UserSubmit, UsersEntity, IVerify, IChangePassword } from '@/store/models';
import {
  fetchProfile,
  loginUser,
  updateUser,
  setUser,
  deactivateProfile,
  logoutUser,
  refreshCurrentUser,
  businessUsers,
  registerUser,
  requestToJoin,
  createOrganization,
  verifyNewUser,
  resendVerificationLink,
  resetPasswordLink,
  changePassword,
} from '@/store/api';

@Module({
  namespaced: true,
  name: 'users',
  store,
  dynamic: true,
})
class UsersModule extends VuexModule {
  public user: User | null = null;
  public profile: Profile | null = null;
  public users: UsersEntity[] = [];
  public registeruser: any = null;

  get username() {
    return (this.user && this.user.name) || null;
  }

  get userid() {
    return (this.user && this.user.id) || null;
  }

  get useremail() {
    return (this.user && this.user.email) || null;
  }

  get businessLicence() {
    return store.getters.currentUser ? store.getters.currentUser.business_licence : null;
  }

  @Action
  public async createNewBusiness(organization: any) {
    return await createOrganization(organization);
  }

  @Action
  public async verifyUser(user: IVerify) {
    return await verifyNewUser(user);
  }

  @MutationAction
  public async login(userSubmit: UserSubmit) {
    const user = await loginUser(userSubmit);
    setUser(user);
    store.commit('setUser', user);
    return { user };
  }

  @MutationAction
  public async refresh() {
    const user = await refreshCurrentUser();
    setUser(user);
    store.commit('setUser', user);
    return { user };
  }

  @MutationAction
  public async logout(id: number) {
    store.commit('setUser', null);
    store.commit('setRefreshToken', false);
    store.commit('logout', {});
    const user = await logoutUser(id);
    return { user };
  }

  @MutationAction
  public async loadProfile(username: string) {
    const profile = await fetchProfile(username);
    return { profile };
  }

  @MutationAction
  public async updateSelfProfile(userUpdateFields: UsersEntity) {
    return await updateUser(userUpdateFields).then((result) => {
      return result;
    });
  }

  @MutationAction
  public async deactivate(id: number) {
    const user = await deactivateProfile(id);
    if (!user)
      store.commit('logout');
    return { user };
  }

  @MutationAction
  public async getBusinessUsers(payload: any) {
    const users = await businessUsers(payload);
    return { users };
  }

  @Action
  public async resetPasswordCode(email: string) {
    return await resetPasswordLink(email);
  }

  @Action
  public async changeUserPassword(payload: IChangePassword) {
    return await changePassword(payload);
  }
}

export default getModule(UsersModule);
